module.exports = __webpack_public_path__ + "img/poster_Radical_Transpaency_R2.9c86e035.jpg";